import { NgModule } from "@angular/core";

import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import * as fromInterceptor from "./interceptors";
import * as fromService from "./services";
import { AuthGuard, AuthoritiesGuard, AuthGuardLogged } from "./guards";
import { authReducer } from "./store/reducers";
import { AuthEffects } from "./store/effects/auth.effects";

@NgModule({
  imports: [
    StoreModule.forFeature("auth", authReducer),
    EffectsModule.forFeature([AuthEffects])
  ],
  providers: [
    ...fromInterceptor.interceptors,
    ...fromService.services,
    AuthGuard,
    AuthoritiesGuard,
    AuthGuardLogged
  ]
})
export class DomainAuthModule {}
